import '../Styles/TableStyles.css';
import React, {useRef} from 'react';

import { Component } from 'preact';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-js-pagination';
import Checkbox from "@material-ui/core/Checkbox";
import Switch from 'preact-material-components/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Button from 'react-bootstrap/Button';
import Formfield from 'preact-material-components/FormField';
import { useDownloadExcel } from 'react-export-table-to-excel';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
class TableUserData extends Component {

  constructor(props){
    super(props)
    this.state = {
      activePage : 1, //pagina activa inicial en pagination
      itemsCountPerPage:1000, //items por pagina en pagination
      tableColumns:[], //columnas de tabla
      tableRows:[], //filas de tabla
      data:[], //data total en tabla
      switch:true,
      switchHighlighted:false,

    }
    this.mount_Table = this.mount_Table.bind(this);
    this.update_Table = this.update_Table.bind(this);
    this.highlightPoints = this.highlightPoints.bind(this);
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentDidUpdate(prevProps){

    if(!(prevProps.detrital_data.length == this.props.detrital_data.length)){
      this.mount_Table(this.props);
    }

    if(!(prevProps.filteredData_detrital.length == this.props.filteredData_detrital.length)){
      this.update_Table(this.props);
    }
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentWillReceiveProps(nextProps) {
    //this.setState({activePage:1});
    //this.update_Table(nextProps);
  }
  /*
  * Método para resaltar puntos (check button)
  */
  highlightPoints(item){
    this.props.clkSeleccDetrital(item);
  }

  /*
  * Dibujo las columnas de la tabla
  */
  mount_Table(props){
    var tableColumns = [];
    var arrColumns = ['Sample',
    "Categorized as Alaskan ultramafic","Categorized as Alkali/ Lamprophyres","Categorized as Basalt","Categorized as Komatiite",
    "Categorized as Layered intrusion","Categorized as Metamorphic","Categorized as Ophiolite","Categorized as Xenoliths",
    'Ti','Al','Cr','Fe3','Fe2','Mg',
    'TiO2','Al2O3','Cr2O3','FeO','Fe2O3','MgO',
    'MgAl2O4','FeAl2O4','MgFe2O4','FeFe2O4','MgCr2O4','FeCr2O4','Mg2TiO4','Fe2TiO4'];

    //Completo las columnas
    tableColumns.push(<th>#</th>);
    //tableColumns.push(<th>checked</th>);
    {Array.from({ length: arrColumns.length }).map((_, index) => (
      tableColumns.push(<th key={index} id={arrColumns[index]}>{arrColumns[index]}</th>)))}
      this.setState({tableColumns:tableColumns});

      const arr = [];
      const arr_filterHigligthed = [];
      var data = props.detrital_data;


      for (let i = 0; i< data.length; i++) {
        arr.push([
          data[i].Sample,
          +data[i].alaskanultramafic,
          +data[i].alkalilamprophyres,
          +data[i].basalt,
          +data[i].komatiite,
          +data[i].layeredintrusion,
          +data[i].metamorphic,
          +data[i].ophiolite,
          +data[i].xenoliths,
          +data[i].Ti,
          +data[i].Al,
          +data[i].Cr,
          +data[i].Fe3,
          +data[i].Fe2,
          +data[i].Mg,
          +data[i].TiO2,
          +data[i].Al2O3,
          +data[i].Cr2O3,
          +data[i].FeO,
          +data[i].Fe2O3,
          +data[i].MgO,
          +data[i].MgAl2O4,
          +data[i].FeAl2O4,
          +data[i].MgFe2O4,
          +data[i].FeFe2O4,
          +data[i].MgCr2O4,
          +data[i].FeCr2O4,
          +data[i].Mg2TiO4,
          +data[i].Fe2TiO4,
        ]);
      }
      this.setState({data:arr},()=>this.update_Table(props,props.filteredData_detrital));
    }

    /*
    * Dibujo las filas de la tabla
    */
    update_Table(props){

      //Completo las filas
      var row = [];
      var end = this.state.itemsCountPerPage;
      if(props.detrital_data.length<end)
      end = props.detrital_data.length;

      var scaleColor = d3.scaleOrdinal()
      .domain(["Alaskan ultramafic","Alkali/ Lamprophyres","Basalt","Komatiite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
      .range(["#ED1909","#1E90FF", "#F062CB", "#AA30FF", "#C0FF30", "#FF6347","#30FF40", "#304FFF"])

      let backgroundColor = "#ffffff";
      let arr = this.state.data;
      var tableRows = [];

      function hexToRgb(hex,opacity) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
          return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var aux = "rgba("+
        parseInt(result[1], 16)+","+
        parseInt(result[2], 16)+","+
        parseInt(result[3], 16)+","+
        opacity+")";

        return "rgba("+
        parseInt(result[1], 16)+","+
        parseInt(result[2], 16)+","+
        parseInt(result[3], 16)+","+
        opacity+")"

      }


      let checked = false;
      for(let i = 0; i < end; i++){
        if(this.state.switch){ //all samples
          checked = (props.filteredData_detrital.includes(i))? true:false;
          backgroundColor = checked?"#BEBEBE":"#FFFFFF";
          row.push(<td style={{backgroundColor:backgroundColor}}><text>{i}</text></td>);
          /*row.push(<td style={{backgroundColor:backgroundColor,width:"8px"}}>
          <Checkbox
          style={{height:"5px",width:"5px"}}
          id="controlled-checkbox"
          checked={checked}
          onClick={() => this.highlightPoints(i)}
          /></td>);*/
          row.push(<td key={i+""+0}> {arr[i][0]}</td>);
          //Alaskan
          row.push(<td key={i+""+1} style={{backgroundColor:hexToRgb(scaleColor("Alaskan ultramafic"),arr[i][1]/100),color:"#000000"}}> {arr[i][1]+"%"}</td>);
          //Alkali
          row.push(<td key={i+""+2} style={{backgroundColor:hexToRgb(scaleColor("Alkali/ Lamprophyres"),arr[i][2]/100),color:"#000000"}}> {arr[i][2]+"%"}</td>);
          //basalt
          row.push(<td key={i+""+3} style={{backgroundColor:hexToRgb(scaleColor("Basalt"),arr[i][3]/100),color:"#000000"}}> {arr[i][3]+"%"}</td>);
          //Komatiite
          row.push(<td key={i+""+4} style={{backgroundColor:hexToRgb(scaleColor("Komatiite"),arr[i][4]/100),color:"#000000"}}> {arr[i][4]+"%"}</td>);
          //Layered intrusion
          row.push(<td key={i+""+5} style={{backgroundColor:hexToRgb(scaleColor("Layered intrusion"),arr[i][5]/100),color:"#000000"}}> {arr[i][5]+"%"}</td>);
          //Metamorphic
          row.push(<td key={i+""+6} style={{backgroundColor:hexToRgb(scaleColor("Metamorphic"),arr[i][6]/100),color:"#000000"}}> {arr[i][6]+"%"}</td>);
          //Ophiolite
          row.push(<td key={i+""+7} style={{backgroundColor:hexToRgb(scaleColor("Ophiolite"),arr[i][7]/100),color:"#000000"}}> {arr[i][7]+"%"}</td>);
          //Xenoliths
          row.push(<td key={i+""+8} style={{backgroundColor:hexToRgb(scaleColor("Xenoliths"),arr[i][8]/100),color:"#000000"}}> {arr[i][8]+"%"}</td>);
          for(let j = 9; j< arr[i].length;j++){

            row.push(<td key={i+""+j}> {arr[i][j]}</td>);
          }

          tableRows.push(<tr key={"f"+i}>{row}</tr>);
          row = [];
        }
        else { //only selected samples
          checked = (props.filteredData_detrital.includes(i))? true:false;
          backgroundColor = checked?"#BEBEBE":"#FFFFFF";
          if(checked){
            row.push(<td style={{backgroundColor:backgroundColor}}><text>{i}</text></td>);
            /*row.push(<td style={{backgroundColor:backgroundColor,width:"8px"}}>
            <Checkbox
            style={{height:"5px",width:"5px"}}
            id="controlled-checkbox"
            checked={checked}
            onClick={() => this.highlightPoints(i)}
            /></td>);*/
            row.push(<td key={i+""+0}> {arr[i][0]}</td>);
            //Alaskan
            row.push(<td key={i+""+1} style={{backgroundColor:hexToRgb(scaleColor("Alaskan ultramafic"),arr[i][1]/100),color:"#000000"}}> {arr[i][1]+"%"}</td>);
            //Alkali
            row.push(<td key={i+""+2} style={{backgroundColor:hexToRgb(scaleColor("Alkali/ Lamprophyres"),arr[i][2]/100),color:"#000000"}}> {arr[i][2]+"%"}</td>);
            //basalt
            row.push(<td key={i+""+3} style={{backgroundColor:hexToRgb(scaleColor("Basalt"),arr[i][3]/100),color:"#000000"}}> {arr[i][3]+"%"}</td>);
            //Komatiite
            row.push(<td key={i+""+4} style={{backgroundColor:hexToRgb(scaleColor("Komatiite"),arr[i][4]/100),color:"#000000"}}> {arr[i][4]+"%"}</td>);
            //Layered intrusion
            row.push(<td key={i+""+5} style={{backgroundColor:hexToRgb(scaleColor("Layered intrusion"),arr[i][5]/100),color:"#000000"}}> {arr[i][5]+"%"}</td>);
            //Metamorphic
            row.push(<td key={i+""+6} style={{backgroundColor:hexToRgb(scaleColor("Metamorphic"),arr[i][6]/100),color:"#000000"}}> {arr[i][6]+"%"}</td>);
            //Ophiolite
            row.push(<td key={i+""+7} style={{backgroundColor:hexToRgb(scaleColor("Ophiolite"),arr[i][7]/100),color:"#000000"}}> {arr[i][7]+"%"}</td>);
            //Xenoliths
            row.push(<td key={i+""+8} style={{backgroundColor:hexToRgb(scaleColor("Xenoliths"),arr[i][8]/100),color:"#000000"}}> {arr[i][8]+"%"}</td>);
            for(let j = 9; j< arr[i].length;j++){

              row.push(<td key={i+""+j}> {arr[i][j]}</td>);
            }

            tableRows.push(<tr key={"f"+i}>{row}</tr>);
            row = [];
          }

        }

      }
      this.setState({tableRows:tableRows});

    }

    /*
    * Modifico las filas visibles en la tabla al seleccionar una pagina nueva del pagination
    */
    handlePageChange(pageNumber) {

      //Completo las filas
      var row = [];
      let arr = this.state.data;
      var tableRows = [];
      let backgroundColor = "#ffffff";
      var end = pageNumber*this.state.itemsCountPerPage;
      if(this.props.detrital_data.length<end)
      end = this.props.detrital_data.length;

      let checked = false;
      for(let i = (pageNumber-1)*this.state.itemsCountPerPage; i < end; i++){
        checked = (this.props.filteredData_detrital.includes(i))? true:false;
        backgroundColor = checked?"#000000":"#FFFFFF";
        color
        row.push(<td style={{backgroundColor:backgroundColor}}><text>{i}</text></td>);
        /*row.push(<td style={{backgroundColor:backgroundColor,width:"8px"}}>
        <Checkbox
        style={{height:"5px",width:"5px"}}
        id="controlled-checkbox"
        checked={checked}
        onClick={() => this.highlightPoints(i)}
        /></td>);*/
        row.push(<td key={i+""+0}> {arr[i][0]}</td>);
        //Alaskan
        row.push(<td key={i+""+1} style={{backgroundColor:hexToRgb(scaleColor("Alaskan ultramafic"),arr[i][1]/100),color:"#000000"}}> {arr[i][1]+"%"}</td>);
        //Alkali
        row.push(<td key={i+""+2} style={{backgroundColor:hexToRgb(scaleColor("Alkali/ Lamprophyres"),arr[i][2]/100),color:"#000000"}}> {arr[i][2]+"%"}</td>);
        //basalt
        row.push(<td key={i+""+3} style={{backgroundColor:hexToRgb(scaleColor("Basalt"),arr[i][3]/100),color:"#000000"}}> {arr[i][3]+"%"}</td>);
        //Komatiite
        row.push(<td key={i+""+4} style={{backgroundColor:hexToRgb(scaleColor("Komatiite"),arr[i][4]/100),color:"#000000"}}> {arr[i][4]+"%"}</td>);
        //Layered intrusion
        row.push(<td key={i+""+5} style={{backgroundColor:hexToRgb(scaleColor("Layered intrusion"),arr[i][5]/100),color:"#000000"}}> {arr[i][5]+"%"}</td>);
        //Metamorphic
        row.push(<td key={i+""+6} style={{backgroundColor:hexToRgb(scaleColor("Metamorphic"),arr[i][6]/100),color:"#000000"}}> {arr[i][6]+"%"}</td>);
        //Ophiolite
        row.push(<td key={i+""+7} style={{backgroundColor:hexToRgb(scaleColor("Ophiolite"),arr[i][7]/100),color:"#000000"}}> {arr[i][7]+"%"}</td>);
        //Xenoliths
        row.push(<td key={i+""+8} style={{backgroundColor:hexToRgb(scaleColor("Xenoliths"),arr[i][8]/100),color:"#000000"}}> {arr[i][8]+"%"}</td>);
        for(let j = 9; j< arr[i].length;j++){

          row.push(<td key={i+""+j}> {arr[i][j]}</td>);
        }

        tableRows.push(<tr key={"f"+i}>{row}</tr>);
        row = [];

      }
      this.setState({tableRows:tableRows});
      this.setState({activePage: pageNumber});



    }


    render(){
      const tableRef = useRef(null);

      const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Users table',
        sheet: 'Users'
      })
      return (
        <div class="container-Table">
        <Row>
        <Col xs={5}>
        <Pagination
        activePage={this.state.activePage}
        itemsCountPerPage={this.state.itemsCountPerPage}
        totalItemsCount={this.props.detrital_data.length}
        pageRangeDisplayed={10}
        onChange={this.handlePageChange.bind(this)}
        onClick={console.log("")}
        />
        </Col>
        </Row>
        <Row>
        <Col xs={5}>
        <ListGroup horizontal defaultActiveKey="1" style={{positon:"relative",right:"0px"}}>
        <ListGroup.Item href="1" onClick={(e)=>{this.setState({switch:true},()=>this.update_Table(this.props));}}>
        View all samples
        </ListGroup.Item>
        <ListGroup.Item  href="2" onClick={(e)=>{this.setState({switch:false},()=>this.update_Table(this.props));}}>
        Filter unselected samples
        </ListGroup.Item>
        </ListGroup>

        </Col>
        </Row>


        <div class="table-responsive-md">
        <Table ref={tableRef} bordered hover>
        <thead>
        <tr>
        {this.state.tableColumns}
        </tr>
        </thead>
        <tbody>
        {this.state.tableRows}
        </tbody>
        </Table>
        </div>
        <br/>
        <Button id="dropdown-basic-button"  onClick={onDownload}>Export Table to EXCEL</Button>
        </div>
      );
    }

  }
  export default TableUserData;
  /*
  <text class="textSwitch switch-table" >Filter selected data</text>

  <Switch  class="switch-table switch" checked={this.state.switch} onChange={e =>{this.setState({switch:!this.state.switch},()=>this.update_Table(this.props)); }}/>

  */
